import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field, SubmissionError } from 'redux-form';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import sha256 from 'crypto-js/sha256';
import Base64 from 'crypto-js/enc-base64';
import Select from 'react-select';
import { setLanguage } from 'redux-i18n';

import { validate } from '../validators/register-validators';
import registerConstants from '../constants/register-constants';
import CookiesWrapper from '../../../../common/cookies-wrapper';
import DefaultInput from '../../../shared/default-input/components/default-input';
import DefaultSelect from '../../../shared/default-select/components/default-select';
import DefaultChecbox from '../../../shared/default-checkbox/components/default-checkbox';
import Button from '../../../shared/button/components/button';
import Footer from '../../../shared/footer/components/footer';
import RegisterHelpers from '../helpers/register-helpers';
import RenderIf from '../../../shared/render-if/components/render-if';
import constants from '../../../../common/constants';
import RegisterTitle from './register-title';
import RadioButtonGroup from '../../../shared/radio-button-group/components/radio-button-group';
import { register, handleRegisterError, getCountries, checkUserExist, handleCheckUserExist } from '../actions/register-actions';
import Helpers from '../../../../common/helpers';
import MessageBox from '../../../shared/error-message/components/message-box';
import messageBoxConstants from '../../../shared/error-message/constants/message-box-constatns';
import { IconOption, IconValue } from '../../../shared/custom-select/components/icon-select';

import '../styles/register.css';

class RegisterFirstStep extends Component {
  state = {
    user_type: RegisterHelpers.getUserType(this.props.location),
    currency: RegisterHelpers.getCurrency(),
    status: registerConstants.user_status.individual,
    errors: null,
    checkbox_values: {
      terms: RegisterHelpers.getTermsValue(),
    },
    fields_display: {
      client_communication: {
        value: 'true',
      },
    },
  };

  componentDidMount() {
    const { location, setLanguage } = this.props;

    // if entered step is incorrect, return user to step 1
    if (!this.props.params || !this.props.params.step || !registerConstants.form_steps[this.props.params.step]) {
      browserHistory.push('/register/1');
      return;
    }

    if (location && location.query && location.query.lang) {
      localStorage.setItem(constants.language_key_word, location.query.lang);
      setLanguage(location.query.lang);
    }

    const userRegisterObject = RegisterHelpers.getUserRegisterObject();
    const { user_type, status, currency } = this.state;

    // initialize user object in local storage
    if (!userRegisterObject || _.isEmpty(userRegisterObject)) {
      localStorage.setItem(
        constants.user_register_key_word,
        JSON.stringify({
          user_type,
          status,
          currency,
        })
      );
    } else {
      const registerObj = Object.assign(userRegisterObject, {
        status,
        currency,
      });
      localStorage.setItem(constants.user_register_key_word, JSON.stringify(registerObj));
    }

    const { countries, getCountries } = this.props;

    if (!countries || countries.length === 0) {
      getCountries();
    }

    RegisterHelpers.setUtmParams(location);
  }

  clearErrors(event, field) {
    const { handleRegisterError } = this.props;

    this.setState({ errors: null });
    handleRegisterError(null);
    handleCheckUserExist({});
  }

  onChangeUserType(value) {
    const { change } = this.props;
    change(registerConstants.fields.user_type, value);
    this.setState({ user_type: value });

    let userRegisterObject = localStorage.getItem(constants.user_register_key_word);
    userRegisterObject = JSON.parse(userRegisterObject);
    userRegisterObject.user_type = value;
    localStorage.setItem(constants.user_register_key_word, JSON.stringify(userRegisterObject));
  }

  onChangeStatus(value) {
    const { change } = this.props;
    change(registerConstants.fields.status, value);
    this.setState({ status: value });
  }

  getTermsUrl(values) {
    if (values && values.user_type) {
      switch (values.user_type) {
        case registerConstants.user_types.ib:
          return registerConstants.introducer_agreement;
        case registerConstants.user_types.affiliate:
          return registerConstants.online_affiliate_agreement;
        default:
          return registerConstants.ifs_agreement;
      }
    }

    return '';
  }

  handlePhoneCodeChange = country => {
    if (country && country.phone_code) {
      this.props.change('code', country.phone_code);
      this.setState({ dialingCode: country });
    }
  };

  renderPhoneCodeField = () => {
    const { countries } = this.props;

    return (
      <Select
        className="custom-select phone-code-wrapper"
        onChange={this.handlePhoneCodeChange}
        inputProps={{ autoComplete: 'none' }}
        optionComponent={IconOption}
        options={countries}
        filterOption={this.handleFilterOption}
        value={this.state.dialingCode}
        placeholder=""
        customTitle={true}
        valueKey="phone_code"
        labelKey="phone_code"
        autocomplete="off"
        clearable={false}
      />
    );
  };

  renderPhoneField = () => {
    const { isDisabled, countries } = this.props;
    const phoneCodeSelected = this.state.dialingCode && this.state.dialingCode.phone_code;
    const validationError = phoneCodeSelected ? null : 'REGISTER.PHONE_NUMBER_REQUIRED';

    return (
      <div className="phone-wrapper">
        <Field disabled={isDisabled} name="code" type="text" component={this.renderPhoneCodeField} props={{ countries, selectedValue: this.state.dialingCode }} />
        <Field disabled={isDisabled} className="phone-number" name="telephone" type="text" placeHolder="REGISTER.PHONE_NUMBER" customError={validationError} component={DefaultInput} />
      </div>
    );
  };

  handleCountryChange = country => {
    if (country && country.code) {
      this.props.change('addr_country', country.code);
      this.props.change('code', country.phone_code);
      this.setState({ country: country, dialingCode: country });
    }
  };

  renderCountryField = ({ label, meta: { touched, error } }) => {
    const { countries } = this.props;
    const { t } = this.context;
    const hasError = touched && error && !this.state.country;

    return (
      <div className="country-select-wrapper">
        <div className="select-and-error">
          <Select
            className={`custom-select ${hasError ? 'input-error' : ''}`}
            onChange={this.handleCountryChange}
            inputProps={{ autoComplete: 'none' }}
            optionComponent={IconOption}
            valueComponent={IconValue}
            options={countries}
            value={this.state.country}
            placeholder={t(label)}
            valueKey="code"
            labelKey="name"
            autocomplete="off"
            clearable={false}
          />
          {hasError && <div className="error">{this.context.t(error)}</div>}
        </div>
      </div>
    );
  };

  getField(field, formValues) {
    const { httpInProgress, countries, userExist } = this.props;
    const { errors } = this.state;
    const allErrors = Object.assign(errors || {}, userExist);
    const label = formValues[field.skip_username_validation_field] && formValues[field.skip_username_validation_field] === field.skip_username_validation_value ? field.alternative_label : field.label;
    const userRegisterObject = RegisterHelpers.getUserRegisterObject();
    const externalUrl = field.name === registerConstants.fields.terms ? this.getTermsUrl(userRegisterObject) : field.externalUrl;

    switch (field.type) {
      case constants.input_types.checkbox:
        return (
          <Field
            name={field.name}
            value={false}
            placeHolder={label}
            disabled={httpInProgress}
            externalUrl={externalUrl}
            externalUrlLabel={field.externalUrlLabel}
            component={DefaultChecbox}
            customError={allErrors ? allErrors[field.name] : null}
            onChange={() => this.clearErrors()}
          />
        );
      case constants.input_types.select:
        if (field.name === registerConstants.fields.country) {
          return (
            <Field
              disabled={httpInProgress}
              name={field.name}
              inputName={field.name}
              placeHolder={label}
              type={constants.input_types.select}
              component={this.renderCountryField}
              props={{ countries, selectedValue: this.state.country }}
            />
          );
        } else
          return (
            <Field
              name={field.name}
              inputName={field.name}
              placeHolder={label}
              options={field.name === registerConstants.fields.country ? countries : field.options}
              optionLabel={field.option_label}
              optionValue={field.option_value}
              disabled={httpInProgress}
              component={DefaultSelect}
              onChange={e => this.clearErrors(e, field.name)}
              required={field.required}
              customError={allErrors ? allErrors[field.name] : null}
            />
          );
      default:
        if (field.name === registerConstants.fields.phone_number) {
          return this.renderPhoneField();
        } else {
          return (
            <Field
              name={field.name}
              inputName={field.name}
              placeHolder={label}
              type={field.type}
              disabled={httpInProgress}
              component={DefaultInput}
              required={field.required}
              customError={errors ? errors[field.name] : null}
              onChange={() => this.clearErrors()}
            />
          );
        }
    }
  }

  renderFields(fields, checkboxValues) {
    const { formState } = this.props;
    const { fields_display } = this.state;
    const formValues = formState && formState.values ? formState.values : {};
    const userRegisterObject = RegisterHelpers.getUserRegisterObject();

    if (fields && fields.length > 0) {
      return fields.map((field, index) => {
        return (
          <RenderIf
            if={
              ((field.visible === userRegisterObject.user_type || field.visible === registerConstants.visible_all) &&
                (!field.visible_field || (field.visible_field && formValues[field.visible_field] && formValues[field.visible_field].toString() === field.visible_field_value.toString()))) ||
              (fields_display[field.name] && formValues[field.name] === fields_display[field.name].value)
            }
            key={index}
          >
            <div className="col-md-6 m-b-30">{this.getField(field, formValues)}</div>
          </RenderIf>
        );
      });
    } else return null;
  }

  handleFormSubmit(values, step, fields) {
    const { change, params } = this.props;
    const errors = Helpers.validateForm(values, fields);

    if (errors) {
      this.setState({ errors: errors });
      for (var key in errors) {
        throw new SubmissionError({ key: errors[key], _error: `${key} failed!` });
      }
    }

    const userRegisterObject = RegisterHelpers.getUserRegisterObject();
    const data = Object.assign(userRegisterObject, values);
    data.telephone = `${values.code}${values.telephone}`;

    if (params && params.step && params.step === '1' && userRegisterObject[registerConstants.fields.client_communication]) {
      delete userRegisterObject[registerConstants.fields.client_communication];
      change(registerConstants.fields.client_communication, null);
    }

    if (step && step.path) {
      const { user_type, currency, status } = this.state;

      if (user_type && data.user_type !== user_type) {
        data.user_type = user_type;
      }

      if (currency) {
        data.currency = currency;
      }

      if (status) {
        data.status = status;
      }

      localStorage.setItem(constants.user_register_key_word, JSON.stringify(data));
      const { checkUserExist } = this.props;
      checkUserExist(data[registerConstants.fields.user_name], data[registerConstants.fields.email], step.path, data, this.registerUser.bind(this));
    } else {
      this.registerUser(data);
    }
  }

  registerUser(data) {
    const { register } = this.props;
    data.password = sha256(constants.magic_salt + data.password).toString(Base64);

    if (data[registerConstants.fields.user_name] && data[registerConstants.fields.user_type] === registerConstants.user_types.ib) {
      data[registerConstants.fields.user_name] = RegisterHelpers.adjustUsername(data[registerConstants.fields.user_name]);
    }

    if (data.user_type === registerConstants.user_types.ib) {
      data.sub_type = RegisterHelpers.determineUserType(data);
    }

    const utmParams = CookiesWrapper.getCookie(registerConstants.utm_params_cookie);

    if (utmParams) {
      data.invited_by_code = utmParams.refcode;
      data.reason_for_registration = utmParams.reason;
      delete utmParams.refcode;
      delete utmParams.reason;
      data = Object.assign(data, utmParams);
    }

    register(data);
  }

  render() {
    const { handleSubmit, httpInProgress, registerErrors, countries } = this.props;
    const { user_type, status, checkbox_values } = this.state;

    let step = {},
      fields = [];

    if (this.props.params && this.props.params.step) {
      step = registerConstants.form_steps[this.props.params.step] || {};
      const param = this.props.location.query.user_type || RegisterHelpers.getUserRegisterObject();

      if (param && param.user_type) {
        fields = _.filter(step.fields, field => {
          return field.visible === param.user_type || field.visible === registerConstants.visible_all;
        });
      }
    }

    return (
      <div>
        <div className="register-container">
          <RenderIf if={countries && countries.length > 0}>
            <div className="register-container__wrapper">
              <RegisterTitle user_type={user_type} />
              <form noValidate onSubmit={handleSubmit(values => this.handleFormSubmit(values, step, fields))}>
                <div className="row m-t-30 text-center">
                  <RenderIf if={step.value === '2'}>
                    <div className="col-md-12 m-b-30">
                      <RadioButtonGroup value={status} options={registerConstants.status_options} label={'REGISTER.ACCOUNT_STATUS'} onChange={this.onChangeStatus.bind(this)} />
                    </div>
                  </RenderIf>
                  {this.renderFields(step.fields, checkbox_values)}
                  <div className="row">
                    <div className="col-md-12">
                      <MessageBox message={registerErrors} type={messageBoxConstants.message_types.error} />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <Button
                      label={step.path && (user_type !== registerConstants.user_types.ifs_type && user_type !== registerConstants.user_types.b2b) ? 'REGISTER.NEXT' : 'REGISTER.SUBMIT_BTN'}
                      customClass={'affiliate-btn-blue submit-btn m-t-20'}
                      disabled={httpInProgress}
                      type="submit"
                    />
                  </div>
                  <RenderIf if={parseInt(step.value, 10) > 1}>
                    <div className="col-md-12">
                      <Button label={'COMMON.BACK'} customClass={'affiliate-btn-white submit-btn m-t-10'} onClick={() => Helpers.goToPage(`/register/${parseInt(step.value, 10) - 1}`)} />
                    </div>
                  </RenderIf>
                </div>
              </form>
            </div>
          </RenderIf>
        </div>
        <div className="row">
          <div className="col-md-12">
            <Footer hideRiskDisclaimer />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  httpInProgress: state.httpInProgressReducer.httpInProgress,
  registerErrors: state.registerReducer.registerErrors,
  countries: state.registerReducer.countries,
  userExist: state.registerReducer.userExist,
  formState: state.form[registerConstants.form_name],
  initialValues: RegisterHelpers.getUserRegisterObject(),
});

const mapDispatchToProps = dispatch => ({
  register: data => {
    dispatch(register(data));
  },
  handleRegisterError: error => {
    dispatch(handleRegisterError(error));
  },
  getCountries: () => {
    dispatch(getCountries());
  },
  checkUserExist: (username, email, path, registerData, registerCallback) => {
    dispatch(checkUserExist(username, email, path, registerData, registerCallback));
  },
  handleCheckUserExist: data => {
    dispatch(handleCheckUserExist(data));
  },
  setLanguage: lang => {
    dispatch(setLanguage(lang));
  },
});

RegisterFirstStep.contextTypes = {
  t: PropTypes.func.isRequired,
};

RegisterFirstStep = reduxForm({
  form: registerConstants.form_name,
  validate,
})(RegisterFirstStep);

export default connect(mapStateToProps, mapDispatchToProps)(RegisterFirstStep);



// WEBPACK FOOTER //
// ./src/app/main/register/components/register.js